<template>
  <div>
    <div class="card bg-white rounded">
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <feather-icon
            class="mr-4"
            icon="AwardIcon"
            svgClasses="text-black stroke-current w-36.96 h-36.96"
          ></feather-icon>
          <h1 class="md:lg m-0">Experiências</h1>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <span class="my-2 md:text-base">
            <span v-if="!onEditMode()"
              >Já estamos terminando! Conte para a gente quais são as suas
              experiências profissionais.</span
            ><br />
            Adicione <b>todas as experiências profissionais</b> para que nossos
            recrutadores possam te avaliar melhor.<br />Quando finalizar,
            <b>role até o final da página</b> e clique em "<b>{{
              onEditMode() ? "Atualizar" : "Salvar"
            }}</b
            >".
          </span>
        </vs-col>
        <vs-col>
          <vs-checkbox
            class="my-3"
            @change="onNoExperience"
            v-model="noExperience"
            name="experiencia"
          >
            Não possuo experiência profissional
          </vs-checkbox>
        </vs-col>
        <vs-col vs-w="12">
          <vs-button
            class="my-5 mb-2"
            icon="add"
            color="primary"
            type="border"
            @click="goToSaveExperience()"
          >
            Adicionar Nova Experiência
          </vs-button>
        </vs-col>
        <vs-col vs-w="12" class="mb-10">
          <vs-button
            class="my-5 mb-2"
            icon="star"
            color="#7d33ff"
            type="border"
            @click="generateExperiencesFromCV()"
          >
            Criar Experiências a partir do CV
          </vs-button>
          <small>Utilizamos Inteligência Artificial para analisar os dados do arquivo de Currículo. <br>Analise e revise o resultado, e faça as edições que achar necessárias principalmente nas datas.</small>
        </vs-col>
        <vs-col
          class="mb-1"
          vs-w="12"
          v-for="(item, index) in experiencies"
          :key="`experience-card-${index}`"
        >
          <div class="vertical-bar" :style="{ borderColor: color }">
            <vs-row>
              <vs-col vs-w="12" vs-type="flex" vs-justify="space-between">
                <vs-row>
                  <vs-col vs-w="12">
                    <b
                      ><p class="mb-1" v-if="item.business_role != null">
                        {{
                          item.business_role.concat(
                            ` ${
                              item.company_sector != null
                                ? item.company_sector
                                : ""
                            }`
                          )
                        }}
                      </p></b
                    >
                    <p class="mb-1" v-if="item.company != null">
                      {{
                        item.company.concat(
                          ` ${
                            item.ocupation_area != null
                              ? item.ocupation_area
                              : ""
                          }`
                        )
                      }}
                    </p>
                    <p v-if="item.is_current" class="mb-1">
                      Período:
                      <!-- {{
                        item.from_date
                          .concat(" até ")
                          .concat(`${item.to_date != null ? item.to_date : ""}`)
                      }} -->
                      {{
                        (item.from_date) ? 
                            'De ' + item.from_date
                            .concat(` até atualmente`)
                          :
                          (
                            ((item.from_date === null || item.from_date === undefined) && item.to_date) 
                              ? 'Início Não Informado até atualmente'
                              : item.from_date + 'até atualmente' )
                      }}
                    </p>
                    <p v-else class="mb-1">
                      Período:
                      <!-- {{
                        item.from_date
                          .concat(" até ")
                          .concat(`${item.to_date != null ? item.to_date : ""}`)
                      }} -->
                      {{
                        (item.from_date) ? 
                            'De ' + item.from_date
                            .concat(` até ${item.to_date}`)
                            .concat(` (${item.period})`)
                          :
                          (
                            ((item.from_date === null || item.from_date === undefined) && item.to_date) 
                              ? 'Início Não Informado - ' + item.to_date
                              : item.from_date + '- Não Informado' )
                      }}
                    </p>
                    <p class="mb-1 mobile-hidden">
                      Descrição:
                      {{
                        `${item.description != null ? item.description : ""}`
                      }}
                    </p>
                  </vs-col>
                </vs-row>
                <div class="flex">
                  <vs-button
                    size="small"
                    radius
                    color="primary"
                    type="border"
                    icon="edit"
                    class="mr-2"
                    @click="goToSaveExperience(item)"
                  />
                  <vs-button
                    size="small"
                    radius
                    color="primary"
                    type="border"
                    icon="delete"
                    @click="handleDeletePopupActive(item)"
                  />
                </div>
              </vs-col>
              <vs-col class="mobile-hidden" vs-w="12">
                <vs-divider
                  v-if="item.skills != null"
                  class="my-2"
                  position="left"
                  >Habilidades</vs-divider
                >
                <vs-chip
                  v-for="(skill, index) in item.skills"
                  :key="`skill-${index}`"
                  class="ml-1"
                  color="#708090"
                >
                  {{ skill }}
                </vs-chip>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <div class="flex flex-wrap mt-2">
      <backward-button @click="handleBackward" />
      <forward-button @click="handleForward" />
    </div>

    <vs-popup title="Remover Experiência" :active.sync="deletePopupActive">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="start"
          vs-w="12"
        >
          <p>Deseja a Experiência?</p>
        </vs-col>

        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="handleRemoveExperience"
            color="danger"
            type="filled"
          >
            Remover
          </vs-button>
          <vs-button
            class="mx-1"
            @click="() => (deletePopupActive = false)"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ModelSelect } from "vue-search-select";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";

export default {
  data() {
    return {
      deletePopupActive: false,
      noExperience: false,
    };
  },
  watch: {
    noExperience(_value) {
      this.onUnskilled();
    },
  },
  computed: {
    ...mapState("auth", ["auth"]),
    ...mapState("experience", ["experiencies"]),
    ...mapState("company", ["company"]),
    ...mapState("skill", ["experienciesSkills"]),
    ...mapGetters("experience", ["unskilled"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  created() {
    this.googleAnalytics();

    this.fetchExperiences();

    this.noExperience = this.unskilled;

    window.scroll(0, 0);
  },
  methods: {
    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },
    handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },
    async handleForward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      await this.$store.dispatch("step/completeStep");

      await this.$store.dispatch("step/incrementCurrentStep");

      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },
    goToSaveExperience(experience) {
      this.$router.push({
        name: "experience-save",
        params: {
          experience,
        },
      });
    },
    async generateExperiencesFromCV() {
      const maxAttempts = 3;
      const waitTime = 10000; // 10 seconds
      const timeout = 45000;

      // Inicia o loading inicial
      this.$vs.loading({
        text: "Aguarde! Lendo CV e analisando experiências..."
      });

      const makeAttempt = async (attemptNumber) => {
        // Apenas atualiza o texto do loading para tentativas subsequentes
        if (attemptNumber > 1) {
          const loadingMessage = attemptNumber === 2 
            ? "Extraindo dados do CV..."
            : "Criando as experiências...";
            
          this.$vs.loading({
            text: loadingMessage
          });
        }

        let isTimeout = false;
        const timeoutHandler = setTimeout(() => {
          isTimeout = true;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Tempo limite excedido",
            text: "Tente novamente mais tarde.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
          this.fetchExperiences();
        }, timeout);

        try {
          const response = await this.$http.post('/api/v2/assistant/chat', {
            feature: 'talent_curriculum_content_generate',
            feature_data: {
              talent_id: this.auth.user.talent.id,
              data_type: "experiences"
            }
          });
          
          clearTimeout(timeoutHandler);
          
          if (isTimeout) return false;

          if (response.data.answer !== null) {
            this.$vs.loading.close();
            window.woopra.track("generate-experiences-clicked", {
              'experiences': response.data.answer
            });
            this.fetchExperiences();
            return true;
          }
          
          return false;
        } catch (error) {
          clearTimeout(timeoutHandler);
          console.log(`Tentativa ${attemptNumber} falhou:`, error);
          
          // Só fecha o loading se for a última tentativa
          if (attemptNumber === maxAttempts) {
            this.$vs.loading.close();
          }
          return false;
        }
      };

      for (let attemptNumber = 1; attemptNumber <= maxAttempts; attemptNumber++) {
        const success = await makeAttempt(attemptNumber);
        
        if (success) return;

        if (attemptNumber < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, waitTime));
        } else {
          // Garante que o loading está fechado na última tentativa
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Não foi possível obter os dados de experiências",
            text: "Tente novamente em alguns instantes, estamos processando o CV. Caso persista, o formato de CV não foi lido corretamente.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        }
      }
    },
    handleDeletePopupActive: function (experience) {
      this.payload = { ...experience };
      this.deletePopupActive = true;
    },
    async handleRemoveExperience() {
      try {
        this.$vs.loading({
          text: "Removendo...",
        });
        const result = await this.$http.delete(
          `api/v1/experiences/${this.payload.id}`
        );

        if (result.status == 200) {
          this.$vs.loading.close();
          this.deletePopupActive = false;

          const index = this.experiencies.findIndex(
            (exp) => exp.id === this.payload.id
          );

          await this.$store.dispatch("experience/delete", { index });

          this.payload = {
            skills: [],
            index: 0,
            to_date: "",
            period: "",
            company: "",
            from_date: "",
            description: "",
            is_current: false,
            popupActive: false,
            business_role: "",
          };
          this.skills = "";

          this.calculateProgress({
            field: "experience",
            value: this.listExperiencies,
          });
          this.calculateProgress({
            field: "skill",
            value: this.experienciesSkills,
          });
        }
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao deletar a experiência",
          text:
            error.response.data.message ||
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/experience`)
        : this.$ga.page(`${company_label}/step/experience`);
    },
    fetchExperiences() {
      this.$vs.loading();

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=experiences`)
        .then((response) => {
          this.$vs.loading.close();

          const { experiences } = response.data.data;

          this.$store.dispatch("experience/index", experiences);
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },

    onNoExperience(e) {
      noExperience = Boolean(e.target.value);
    },

    ...mapActions("experience", ["removeExperience", "onUnskilled"]),
    ...mapActions("progress", ["calculateProgress"]),
  },
  components: {
    VuePerfectScrollbar,
    ForwardButton,
    BackwardButton,
    ModelSelect,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
</style>
